import React, {Component} from 'react';

export default class ToggleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {value:true}

    this.showContent = false;
  }

  handleClick = () => {
    this.showContent = !this.showContent;

    this.props.onChange(this.showContent);
  }

  render() {
    return(
      <div className="button is-large is-link" onClick={this.handleClick}>
        {this.props.title}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/toggleButton.js